import React from 'react'
import PropTypes from 'prop-types'
import { _InfoDivider } from './styles'

const InfoDivider = ({ dividerText = '|', className = '' }) =>
  <_InfoDivider className={className} role="separator">{dividerText}</_InfoDivider>

InfoDivider.propTypes = {
  dividerText: PropTypes.string,
  className: PropTypes.string,
}

export default InfoDivider
